import { VacancyCreatedHistoryItem } from "./VacancyCreatedHistoryItem";
import { VacancyDeletedHistoryItem } from "./VacancyDeletedHistoryItem";
import { VacancyUpdatedHistoryItem } from "./VacancyUpdatedHistoryItem";

import {
  HistoryEntryDispatcher,
  type EntityHistoryEntry,
  type HistoryItemMap,
} from "@/components/ui/v2/history";

const VACANCY_HISTORY_ITEMS: HistoryItemMap = {
  VacancyCreated: VacancyCreatedHistoryItem,
  VacancyUpdated: VacancyUpdatedHistoryItem,
  VacancyDeleted: VacancyDeletedHistoryItem,
};

export function VacancyHistoryEntryItem({
  entry,
}: {
  entry: EntityHistoryEntry;
}) {
  return (
    <HistoryEntryDispatcher
      entry={entry}
      items={VACANCY_HISTORY_ITEMS}
      i18nPrefix="admin.vacancies.history"
    />
  );
}
